/**
 * Obstruction History Event Type Enum
 *
 * Type of event recorded in obstruction audit-log history. Mirrors backend
 * `GeoMarkup.Domain.Enums.ObstructionHistoryEventType` — stored as PascalCase strings.
 */
export enum ObstructionHistoryEventType {
  /** Obstruction was created. */
  Created = 'Created',
  /** Obstruction metadata was updated. */
  Updated = 'Updated',
  /** Obstruction status was changed. */
  StatusChanged = 'StatusChanged',
  /** Obstruction geometry collection was modified. */
  GeometryChanged = 'GeometryChanged',
  /** Obstruction sign collection was modified. */
  SignsChanged = 'SignsChanged',
  /** Contractor data was changed. */
  ContractorChanged = 'ContractorChanged',
  /** Obstruction was deleted. */
  Deleted = 'Deleted',
}
